import { render, staticRenderFns } from "./QuickLinksCard.vue?vue&type=template&id=da1061ec&scoped=true&"
import script from "./QuickLinksCard.vue?vue&type=script&lang=js&"
export * from "./QuickLinksCard.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinksCard.vue?vue&type=style&index=0&id=da1061ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1061ec",
  null
  
)

export default component.exports